<template>
  <div :class="$style.kioskTryBlock"
       :style="backgroundStyle">
    <div :class="$style.overlay" />

    <div :class="$style.kioskTryContent">
      <h2 :class="$style.kioskTryTitle">
        Try Our <span> Vegan Black Bean Patty </span>
      </h2>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import background from '@/assets/img/burger-bg.png';

/* Provide bottom advertisement */
@Component({
  components: {},
})
export default class KioskTryBlock extends Vue {
  get backgroundStyle() {
    return { 'background-image': `url(${background})` };
  }
}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';

.kioskTryBlock {
  height: 260px;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $overlay-color;
    opacity: 0.4;
    z-index: 2;
  }
}

.kioskTryContent {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 3;
}
.kioskTryTitle {
  color: $white;
  font-size: 40px;
  font-weight: 700;
  line-height: 38px;
  letter-spacing: -0.56px;
  text-transform: uppercase;
  span {
    display: block;
    font-family: 'Dekers', sans-serif;
    font-size: 41px;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/KioskTryBlock.vue